// extracted by mini-css-extract-plugin
export default {"Container":"Form_Container__yPFX2","Tagline":"Form_Tagline__q1x-u","TextInline":"Form_TextInline__+RPO6","ClickableText":"Form_ClickableText__hR++a"};